import { Suspense } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { m } from "framer-motion";
import { PageLoadingFallback } from "../common/PageLoadingFallback";

export function AnimatedOutlet() {
  const location = useLocation();

  return (
    <m.div
      key={location.pathname}
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2 }}
    >
      {/* Single Suspense boundary for every AppShell-nested route below —
          each route's element is now React.lazy(...) (see routes.tsx), so
          this covers all of them without wrapping each one individually. */}
      <Suspense fallback={<PageLoadingFallback />}>
        <Outlet />
      </Suspense>
    </m.div>
  );
}
